
import { IFileModel } from "../../model/FileModel.model";
import { Vue, Options } from "vue-class-component";
import { watchEffect } from "vue";
import LayoutService from "../../services/layout.service";
import { IGalleria } from "../../model/IGalleria.model";
import { IImage } from "../../model/IImage.model";
import { useStore } from "../../store";
import { MutationTypes } from "../../store/mutations";
@Options({
  props: ["multi", "imageUrl", "onlyIcon", "imageType"]
})
export default class UploadImage extends Vue {
  multi!: boolean;
  imageUrl!: any;
  imageType!: any;
  url = "";
  images: IImage[] = [];
  displayBasic2 = false;
  onlyIcon!: boolean;
  public store = useStore();
  handleFileChange(event: any) {
    const files = event.target.files as IFileModel[];
    if (files) {
      for (const file of files) {
        file.imageType = this.imageType as string;
        this.uploadFile(file);
        this.store.commit(MutationTypes.ADD_FILE_AWAIT_UPLOAD, file);
      }
    }
  }

  uploadFile(file: any) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.url = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  created() {
    watchEffect(() => {
      this.$emit("update:imageUrl", this.url);
    });
  }

  removeImageQuestion() {
    this.$emit("update:imageUrl", "");
  }

  openGalleria() {
    if (!this.onlyIcon) {
      const galleria: IGalleria = {
        visible: true,
        value: [
          {
            src: this.imageUrl,
            alt: "image"
          }
        ]
      };
      LayoutService.setGalleria(galleria);
    }
  }
}
